import React, { useEffect, useState } from 'react'
import { Box, Button, Title, Flex, Card, Skeleton, Grid } from '@mantine/core'
import UsersTable from '../components/Users/UsersTable'
import ModalUsers from '../components/Users/Modal'
import { useUserStore } from '../store/useUserStore'

const Users = () => {
  const { users, loading, getUserList, deleteUser } = useUserStore();
  const [item, setItem] = useState(null)
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    getUserList();
  }, [])

  const onOpen = (item) => {
    setIsOpen(true);
    setItem(item);
  }
  const onClose = () => {
    setIsOpen(false);
    setItem(null);
  }

  return (
    <>
      <Box className='w-full gap-1 h-[100vh] py-2 px-2'>
        <Flex justify="space-between" px="md" pb="lg" align="center">
          <Box>
            <Title order={1}>Gestión de Operadores</Title>
            <Title order={5} fw={400} c="dimmed">Administra los accesos y roles del sistema</Title>
          </Box>
          <Button size="md" onClick={() => onOpen(null)}>Nuevo Usuario</Button>
        </Flex>

        <Box className='w-full py-1 rounded flex flex-col items-center justify-center'>
          {!loading ? (
            <UsersTable items={users} onOpen={onOpen} remove={deleteUser} />
          ) : (
            <Card shadow="md" p="xl" withBorder mx="md" w="100%" my="xs">
              <Grid w="100%">
                {[1, 2, 3, 4].map(index => (
                  <Skeleton key={index} height={60} radius="md" my="xs" />
                ))}
              </Grid>
            </Card>
          )}
        </Box>
      </Box>
      <ModalUsers isOpen={isOpen} onClose={onClose} item={item} />
    </>
  )
}

export default Users
